import { createSlice } from '@reduxjs/toolkit';

const overlaySlice = createSlice({
  name: 'overlay',
  initialState: {
    showPlayerListOverlay: false,
    isTeamNameOverlayVisible: false,
    playerInfoOverlayVisible: false,
    playerCard: null,
    disableClassName: false,
    showPlayerSectionCTA: true
  },
  reducers: {
    handlePlayerInfoOverlay: (state, action) => {
      return {
        ...state,
        showPlayerListOverlay: action.payload
      };
    },
    showTeamNameOverlay(state, action) {
      state.isTeamNameOverlayVisible = action.payload;
    },
    setPlayerInfoOverlay(state, action) {
      state.playerInfoOverlayVisible = action.payload;
    },
    setPlayerCard(state, action) {
      state.playerCard = action.payload;
    },
    setClassName(state, action) {
      state.disableClassName = action.payload;
    },
    setShowPlayerSectionCTA(state, action) {
      state.showPlayerSectionCTA = action.payload;
    }
  }
});

export const {
  handlePlayerInfoOverlay,
  showTeamNameOverlay,
  setPlayerInfoOverlay,
  setPlayerCard,
  setClassName,
  setShowPlayerSectionCTA
} = overlaySlice.actions;
export default overlaySlice.reducer;
